<template>
  <div class="card min-width-1250px">
    <header class="bandeau-modal card-header"></header>
    <div class="card-content">
      <section class="has-text-centered column is-12">
          <span class="is-size-3 has-text-weight-bold">
            {{ $t('listeFactures.envoiMailMasse.titre') }}
          </span>
      </section>
      <section v-if="!sendEmail">
        <error-msg-component
          :messages="lockMessages"
          :error="isError"
          :messagesChampsVide="[]"
          :champsVide="[]"
          :title="'ajoutDevis.problemOccurred'"
          @close="isError = $event"/>
        <section>
          <qd-steps
            class="step_expanded"
            v-model="activeStep"
            :animated="true"
            :has-navigation="false"
            :destroy-on-hide="true"
            label-position="bottom"
            :disabled="isError"
            :stepsItems="stepsItems">
            <template #selection>
              <facture-mail-tableau :items="items" :disabled="isLock"/>
            </template>
            <template #message>
              <facture-mail-corp
                :mail="mail"
                :editionsAInclure="editionsAInclure"
                :customSubject.sync="customSubject"/>
            </template>
          </qd-steps>
        </section>
        <div>
          <qd-button
              v-if="activeStep === 0"
              class="mgr-2 button btn-modal-annuler"
              type="is-cancel"
              @click="() => $emit('close')">
              {{$t('general.button.cancel')}}
          </qd-button>
          <qd-button
              v-else
              class="mgr-2 button btn-modal-annuler"
              :class="{'button-access-no-permission': activeStep === 0}"
              type="is-cancel"
              :disabled="activeStep === 0"
              @click="() => activeStep -= 1">
              {{$t('general.button.precedent')}}
          </qd-button>
          <qd-button
              v-if="activeStep === numberSteps - 1"
              type="is-addOrEdit"
              @click="envoiMails">
              {{ $t('listeFactures.envoiMailMasse.sendMail') }}
          </qd-button>
          <qd-button
              v-else
              :class="{'button-access-no-permission': activeStep === numberSteps - 1 || isLock}"
              type="is-addOrEdit"
              :disabled="activeStep === numberSteps - 1 || isLock"
              @click="nextStep">
              {{$t('general.button.suivant')}}
          </qd-button>
        </div>
      </section>
      <section v-else
        class="is-flex is-flex-direction-column
        is-justify-content-center is-align-items-center min-height200">
        <section v-if="isSendingMail"
          class="is-flex is-flex-direction-column
          is-justify-content-center is-align-items-center min-height200">
          <span v-if="!allGood" class="is-size-5">
            {{ $t('listeFactures.envoiMailMasse.sendingMail') }}
          </span>
          <span v-else class="is-size-5">
            {{ $t('listeFactures.envoiMailMasse.allMailSended') }}
          </span>
          <qd-progress
            class="width-340 mgt-20px"
            :value="nbSend"
            size="is-medium"
            :max="factures.length"
            :type="allGood ? 'is-success' : 'is-primary'"
            show-value>
            {{ $t('listeFactures.envoiMailMasse.sendedMail',
                {send: nbSend, total: factures.length}) }}
          </qd-progress>
          <qd-button
              v-if="allGood"
              class="mgt-10px"
              type="is-cancel"
              @click="() => $emit('close')">
              {{$t('general.button.close')}}
          </qd-button>
        </section>
        <section v-else
          class="is-flex is-flex-direction-column
          is-justify-content-center is-align-items-center min-height200">
          <qd-message type="is-success">
            {{ $t('listeFactures.envoiMailMasse.allMailSended') }}
          </qd-message>
          <qd-button
              class="mgt-10px"
              type="is-cancel"
              @click="() => $emit('close')">
              {{$t('general.button.close')}}
          </qd-button>
        </section>
      </section>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { cloneDeep, uniq } from 'lodash';
import { generationMailEnMasseFromFacture } from '@/services/dcf/generationMail';
import genererMail from '@/services/general/genererMail';
import { TYPE_EDITION_FACTURE_MAIL } from '@/configuration/facture/factureConf';
import messageErreur from '@/services/general/messageErreur';
import emailAsync from '@/api/mail';
import { TAILLE_PJ_LIMITE } from '@/configuration/piecesJointes';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { REGEX_EMAIL } from '@/configuration/regexConf';
import factureMailTableau from './mailEnMasseStep/FactureMailTableau';
import factureMailCorp from './mailEnMasseStep/factureMailCorp';

const Societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');

export default {
  props: {
    factures: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    factureMailTableau,
    factureMailCorp,
    errorMsgComponent,
  },
  data() {
    return {
      activeStep: 0,
      items: [],
      mail: {},
      isLock: false,
      isError: false,
      lockMessages: [],
      editionsAInclure: [{
        libelle: 'detailFacture.popUpMail.inclureFacture', key: 'mettreEdition', value: true, type: TYPE_EDITION_FACTURE_MAIL,
      }],
      sendEmail: false,
      isSendingMail: true,
      nbSend: 0,
      customSubject: '',
    };
  },
  computed: {
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    numberSteps() {
      return this.stepsItems.length;
    },
    allGood() {
      return this.nbSend === this.factures.length;
    },
    stepsItems() {
      return [
        {
          name: 'selection',
          step: 1,
          label: this.$t('listeFactures.envoiMailMasse.steps.selection.titre'),
          clickable: false,
        },
        {
          name: 'message',
          step: 2,
          label: this.$t('listeFactures.envoiMailMasse.steps.message.titre'),
          clickable: false,
        },
      ];
    },
  },
  methods: {
    nextStep() {
      this.isError = false;
      this.lockMessages = [];
      if (this.items.some(i => i.mail.to.length === 0)) {
        this.isError = true;
        this.lockMessages.push({ message: this.$t('listeFactures.envoiMailMasse.errorDestinataire') });
      }
      const mails = cloneDeep(this.items.map(i => i.mail));
      let errorFormatEmail = false;
      mails.forEach(mail => {
        const destinataires = this.getCleanEmail(mail.to);
        if (destinataires.some(d => !REGEX_EMAIL.test(d))) {
          errorFormatEmail = true;
        }
        if (this.getCleanEmail(mail.cci).some(m => this.getCleanEmail(mail.to).includes(m))) {
          this.isError = true;
          this.lockMessages.push({ message: this.$t('listeFactures.envoiMailMasse.errorAlreadyInCopy') });
        }
        const uniqueDestinataire = [...new Set(destinataires)];
        if (destinataires.length !== uniqueDestinataire.length) {
          this.isError = true;
          this.lockMessages.push({ message: this.$t('listeFactures.envoiMailMasse.errorDupplicateMail') });
        }
      });
      if (errorFormatEmail) {
        this.isError = true;
        this.lockMessages.push({ message: this.$t('listeFactures.envoiMailMasse.errorFormatMail') });
      }
      if (!this.isError) {
        this.activeStep += 1;
      }
    },
    getCleanEmail(emails) {
      return emails.map(m => {
        if (m.email) return m.email;
        return m;
      });
    },
    async envoiMails() {
      this.isError = false;
      this.lockMessages = [];
      this.nbSend = 0;
      if (!this.mail.corps || this.mail.corps === '') {
        this.isError = true;
        this.lockMessages.push({ message: this.$t('listeFactures.envoiMailMasse.errorCorps') });
        return;
      }

      if (this.mail.piecesJointes.some(pj => pj.size > TAILLE_PJ_LIMITE)) {
        this.isError = true;
        this.lockMessages.push({ message: this.$t('listeFactures.envoiMailMasse.errorPjTooBig') });
        return;
      }
      this.sendEmail = true;
      this.isSendingMail = true;
      const factureToSend = cloneDeep(this.items);
      factureToSend.forEach(facture => {
        facture.mail.corps = this.mail.corps;
        facture.mail.piecesJointes = this.mail.piecesJointes;

        if (this.customSubject && this.customSubject.trim() !== '') {
          facture.mail.objet = this.customSubject;
        }

        facture.mail.to = this.getCleanEmail(facture.mail.to);
        facture.mail.cc = this.getCleanEmail(facture.mail.cc);
        facture.mail.cci = this.getCleanEmail(facture.mail.cci);
      });
      const promises = factureToSend.map(facture => {
        return this.envoieMailFacture(facture.mail, facture.id, facture.societeId);
      });
      await Promise.all(promises);
    },
    async envoieMailFacture(mail, elementId, societeId) {
      try {
        const params = {
          mettreEdition: this.editionsAInclure[0].value,
          typeDonnee: this.editionsAInclure[0].type,
          elementId: elementId,
          societeId: societeId,
        };
        const data = new FormData();
        data.append('mailRequest', JSON.stringify(mail));
        if (mail.piecesJointes) {
          mail.piecesJointes.forEach((file) => {
            data.append(file.name, file, file.name);
          });
        }
        await emailAsync(params, data);
        this.nbSend += 1;
      } catch (e) {
        messageErreur(this.$i18n);
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      const agenceIds = this.factures.map(f => f.agenceId);
      const agences = this.societesInformations.map(s => s.agences).flat(2);
      if (uniq(agenceIds).length > 1
      && agences.filter(a => agenceIds.includes(a.id)).some(a => a.emailFacturation)) {
        this.isLock = true;
        this.isError = true;
        this.lockMessages.push({ message: this.$t('listeFactures.envoiMailMasse.errorAgence') });
      }

      if (!this.user.email) {
        this.isLock = true;
        this.isError = true;
        this.lockMessages.push({ message: this.$t('listeFactures.envoiMailMasse.userEmail') });
      }
      const factureMails = await generationMailEnMasseFromFacture(this.factures);
      this.items = cloneDeep(factureMails);

      this.mail = genererMail();
      const agenceId = this.factures.map(f => f.agenceId).shift();
      const agence = this.societesInformations
        .map(s => s.agences)
        .flat(2)
        .find(a => a.id === agenceId);

      if (agence.emailFacturation) {
        this.mail.corps = agence.emailFacturation;
      }
    } catch (e) {
      messageErreur(this.$i18n);
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
